import React, { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Modal,
  Select,
  MenuItem,
  Box,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";
import { selectnodess } from "../redux/nodesSlice";
import { selectgroups } from "../redux/businessSlice";

const Stats = () => {
  const businesses = useSelector(selectgroups); // Business groups

  const allorganization = useSelector(selectnodess); // All organizations
  const branches = allorganization?.filter((org) => org.isBranch === true);
  // console.log("sd", branches);
  // console.log(allorganization, "adedwdwdwedwedalll");
  const [open, setOpen] = useState(false);
  const [selectedDirector, setSelectedDirector] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");

  const [selectedBranch, setSelectedBranch] = useState("");

  // Helper to derive a region/country from an organization location.
  // Prefer an explicit region field, then country code mapping, then fall back to parsing the address.
  const getRegionFromOrg = (org) => {
    const loc = org?.data?.location || org?.location || org?.placelocation || {};
    // 1) explicit region property
    if (loc.region) return loc.region;
    // 2) country code mapping
    const countryCode = (loc.countryName || loc.country || org?.data?.countryName || "").toString();
    if (countryCode) {
      try {
        // Use Intl.DisplayNames when available for robust country code -> full name mapping
        if (typeof Intl !== "undefined" && Intl.DisplayNames) {
          const dn = new Intl.DisplayNames(["en"], { type: "region" });
          const code = countryCode.length === 2 ? countryCode.toUpperCase() : countryCode;
          const name = dn.of(code);
          if (name) return name;
        }
      } catch (e) {
        // ignore and fallback
      }
      const countryMap = { HK: "Hong Kong", HKG: "Hong Kong", GB: "United Kingdom", US: "United States" };
      const mapped = countryMap[countryCode.toUpperCase()];
      if (mapped) return mapped;
      // if it's already a full name, return as-is
      if (countryCode.length > 2) return countryCode;
    }
    // 3) parse from address (take last segment after comma)
    const address = loc.address || loc?.formattedAddress || org?.data?.address || "";
    if (address && typeof address === "string") {
      const parts = address.split(",").map((p) => p.trim()).filter(Boolean);
      if (parts.length) return parts[parts.length - 1];
    }
    // 4) fallback to the location name (may be building) — return empty string so UI can filter it out
    return loc.name || "";
  };

  // Extract unique locations (use region instead of building names)
  const uniqueLocations = [
    ...new Set(allorganization?.map((org) => getRegionFromOrg(org))),
  ]?.filter(Boolean);
  // console.log("branches", branches);

  const uniqueBranchesLocations = [
    ...new Set(branches?.map((org) => getRegionFromOrg(org))),
  ]?.filter(Boolean);
  // console.log("branchesLocation", uniqueBranchesLocations);
  // Directors and their company counts (covers ManagingDirector and Director fields)
  const getDirectorCompanyCounts = (organizations) => {
    if (!organizations || !Array.isArray(organizations)) {
      return [];
    }
    
    const directorCounts = organizations.reduce((acc, org) => {
      // support different possible director fields and arrays
      // 1) array field `directors`
      const directorsArray = Array.isArray(org?.data?.directors) ? org.data.directors.map(d => (d || "").trim()).filter(Boolean) : [];
      if (directorsArray.length) {
        directorsArray.forEach((d) => {
          acc[d] = (acc[d] || 0) + 1;
        });
        return acc;
      }
      // 2) single-value fields
      const director = (org?.data?.ManagingDirector || org?.data?.Director || org?.data?.DirectorName || "").toString().trim();
      if (director) {
        acc[director] = (acc[director] || 0) + 1;
      }
      return acc;
    }, {});
// console.log("selectedBranch",selectedBranch)
    return Object.entries(directorCounts || {}).map(([director, count]) => ({
      name: director,
      companyCount: count,
    }));
  };
  const directorCompanyCounts = getDirectorCompanyCounts(allorganization);
  const handleOpen = (director) => {
    setSelectedDirector(director);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedDirector(null);
  };
  const getCompaniesByDirector = (directorName) => {
    if (!directorName) return [];
    return allorganization?.filter((org) => {
      const directorsArray = Array.isArray(org?.data?.directors) ? org.data.directors.map(d => (d || "").trim()) : [];
      if (directorsArray.length) {
        return directorsArray.includes(directorName);
      }
      const director = (org?.data?.ManagingDirector || org?.data?.Director || org?.data?.DirectorName || "").toString().trim();
      return director === directorName;
    }) || [];
  };
  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
  };
  const handleBranchChange = (event) => {
    setSelectedBranch(event.target.value);
  };
  // Match and Filter Branches
  // const matchAndFilterBranches = (branches, allorganizations) => {
  //   if (!allorganizations || !Array.isArray(allorganizations)) {
  //     return branches || [];
  //   }
    
  //   const organizationMap = allorganizations.reduce((map, org) => {
  //     if (org?.data && org.data.companyName) {
  //       map[org.data.companyName] = {
  //         location: org.data.location?.name || "Unknown Location",
  //         businessGroup: org.data?.BusinessGroup || "Unknown Group",
  //       };
  //     }
  //     return map;
  //   }, {});

  //   return branches?.map((branch) => {
  //     const match = organizationMap[branch?.data?.companyName];
  //     if (match) {
  //       return {
  //         ...branch,
  //         data: {
  //           ...branch.data,
  //           location: match.location,
  //           businessGroup: match.businessGroup,
  //         },
  //       };
  //     }
  //     return branch;
  //   }) || [];
  // };
  // Fetch updated branches
  // const updatedBranches = matchAndFilterBranches(branches, allorganization);
  // Extract unique branches
  // const uniqueBranches = [
  //   ...new Set(
  //     updatedBranches?.map(
  //       (branch) =>
  //         branch.data?.companyName === allorganization.data?.companyName
  //     )
  //   ),
  // ]?.filter(Boolean);
  return (
    <div style={{ padding: "20px" }}>
      <Grid container spacing={4}>
        {/* Total Entities Section */}
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6">Total Entities</Typography>
              <Typography variant="h4">{allorganization?.length}</Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Total Branches Section */}
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6">Total Branches</Typography>
              <Typography variant="h4">{branches?.length}</Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Managing Directors Section */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Directors
              </Typography>
              <Box
                sx={{
                  maxHeight:
                    directorCompanyCounts?.length > 5 ? "200px" : "auto",
                  overflowY:
                    directorCompanyCounts.length > 5 ? "auto" : "visible",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "10px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                {directorCompanyCounts?.map((director, index) => (
                  <div key={director.name} style={{ marginBottom: "10px" }}>
                    <Typography
                      variant="body1"
                      style={{ cursor: "pointer", color: "blue" }}
                      onClick={() => handleOpen(director)}
                    >
                   {index +1 } . <b>{director.name || "No Name Available"}</b>
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Total Companies Owned : {director.companyCount || 0}
                    </Typography>
                  </div>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Modal for Managing Director's Companies */}
        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              borderRadius: "8px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Companies by {selectedDirector?.name}
            </Typography>
            <Box
              sx={{
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "10px",
                marginBottom: "20px",
              }}
            >
              <ul style={{ padding: 0, margin: 0 }}>
                {getCompaniesByDirector(selectedDirector?.name)?.map(
                  (company, index) => (
                    <li
                      key={index}
                      style={{
                        listStyle: "none",
                        marginBottom: "4px",
                        padding: "3px 0",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                    {index + 1} . {company?.data?.companyName}
                    </li>
                  )
                )}
              </ul>
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              fullWidth
            >
              Close
            </Button>
          </Box>
        </Modal>
        {/* Location Filter Dropdown */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Filter Business Nature by Location (Region)
              </Typography>
              <Select
                value={selectedLocation}
                onChange={handleLocationChange}
                displayEmpty
                variant="outlined"
                sx={{ backgroundColor: "#f9f9f9", borderRadius: "4px" }}
              >
                <MenuItem value="">All Locations</MenuItem>
                {uniqueLocations?.map((location, index) => (
                  <MenuItem value={location} key={index}>
                    {location}
                  </MenuItem>
                ))}
              </Select>
            </CardContent>
          </Card>
        </Grid>
        {/* Business Nature Section */}
        {businesses?.map((business) => {
          const matchingOrganizations = allorganization?.filter((org) =>
            org.data?.BusinessGroup === business._id &&
            (selectedLocation ? getRegionFromOrg(org) === selectedLocation : true)
          );
          return (
            <Grid item xs={12} sm={6} md={4} key={business._id}>
              <Card>
                <CardContent>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ textTransform: "capitalize" }}
                  >                  
                    {business.businessNature}
                  </Typography>
                  <Typography variant="body1">
                    <b>Total Companies:</b>
                    <span style={{ cursor: "pointer", color: "blue" }}>
                     {matchingOrganizations?.length}
                    </span>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}

        {/* Branch Filter Section */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Filter by Branches by Location (Region)
              </Typography>
              <Select
                value={selectedBranch}
                onChange={handleBranchChange}
                displayEmpty
                variant="outlined"
                sx={{ backgroundColor: "#f9f9f9", borderRadius: "4px" }}
              >
                <MenuItem value="">All Branches</MenuItem>
                {uniqueBranchesLocations?.map((branch, index) => (
                  <MenuItem value={branch} key={index} >
                    {branch}
                  </MenuItem>
                ))}
              </Select>
            </CardContent>
          </Card>
        </Grid>

        {/* Matching Branches by Business Nature */}
        {businesses?.map((business) => {
          const filterBrancehs = branches?.filter((org) =>
            org.data?.BusinessGroup === business._id &&
            (selectedBranch ? getRegionFromOrg(org) === selectedBranch : true)
          );

          return (
            <Grid item xs={12} sm={6} md={4} key={business._id}>
              <Card>
                <CardContent>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ textTransform: "capitalize" }}
                  >
                    {business.businessNature}
                  </Typography>
                  <Typography variant="body1">
                    <b>Total Branches:</b> <span  style={{ cursor: "pointer", color: "blue" }}>
                    {filterBrancehs?.length}
                    </span>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default Stats;
